import { AuthenticationMeetingsRemindComponent } from '../remind/authentication.meetings.remind.component';
import { Ng2StateDeclaration } from '@uirouter/angular';

import { AuthenticationMeetingsLoginComponent } from '../login/authentication.meetings.login.component';
import { AuthenticationMeetingsRegistrationComponent } from '../registration/authentication.meetings.registration.component';
import { AuthenticationMeetingsConfirmComponent } from '../confirm/authentication.meetings.confirm.component';
import { AuthenticationMeetingsChangePasswordComponent } from '../change_password/authentication.meetings.change_password.component';

export const authenticationMeetingsRoutes: Ng2StateDeclaration[] = [
	{
		name: 'login',
		url: '/login',
		component: AuthenticationMeetingsLoginComponent,
	},
	{
		name: 'confirm',
		url: '/confirm',
		component: AuthenticationMeetingsConfirmComponent,
	},
	{
		name: 'registration',
		url: '/registration',
		component: AuthenticationMeetingsRegistrationComponent,
	},
	{
		name: 'remind',
		url: '/remind',
		component: AuthenticationMeetingsRemindComponent,
	},
	{
		name: 'new_password',
		url: '/applypassword',
		component: AuthenticationMeetingsChangePasswordComponent,
	},
];
